import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

import { Button } from '@mui/material'

export const Wrapper = styled.div`
  border: 1px solid ${theme.colors.neutral.lighthover};
  border-radius: ${theme.shapes.borderRadius.sm};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.md};
`

export const ButtonSap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ButtonsSapWrapper = styled.div`
  display: flex;
  align-items: center;

  gap: ${theme.spacing.xm};
`

export const MessageCheckedOVs = styled.span`
  width: fit-content;
  min-width: 152px;
  height: ${theme.spacing.xl};
  font-weight: ${theme.typography.weight.lg};
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.xs};
  line-height: ${theme.typography.lineHeight.md};

  display: flex;
  align-items: center;
  justify-content: center;
`

export const TextButton = styled(Button)`
  height: ${theme.spacing.xl};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  line-height: ${theme.typography.lineHeight.sm};

  border-radius: ${theme.shapes.borderRadius.sm};
  background: transparent;
  border: none;

  color: ${theme.colors.primary.main};

  &:hover {
    ${theme.colors.primary.hover};
  }

  &:disabled {
    color: ${theme.colors.neutral.lighthover};
    cursor: auto;
  }
`
